import React from "react";
import styled from "styled-components";
import { getColor } from "views/resources/theme";
import { CgHeadset } from "react-icons/cg";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";

import { Typography } from "antd";
import { Spacer } from "views/components/common/Spacer";

const { Text } = Typography;

const iconStyles = { color: "#000", fontSize: 16, marginRight: 5 };

const configObj = {
	attention: {
		icon: <CgHeadset style={iconStyles} />,
		title: "Tipo de atención",
	},
	date: {
		icon: <CalendarOutlined style={iconStyles} />,
		title: "Fecha",
	},
	time: {
		icon: <ClockCircleOutlined style={iconStyles} />,
		title: "Hora",
	},
};
export const AttentionLabel = ({ desktop, type, label }) => {
	return (
		<LabelButtonStyled desktop={desktop}>
			<div style={{ display: "flex", alignItems: "center" }}>
				{configObj[type].icon}
			</div>

			<div className="attention-container">
				{desktop && (
					<div className={"attention-title"}>
						{configObj[type].title}
					</div>
				)}
				<Spacer rows={0.25} />
				{label}
			</div>
		</LabelButtonStyled>
	);
};

export const LabelButtonStyled = styled.button`
	display: flex;
	border: none;
	align-items: center;
	text-align: left;
	background: transparent;
	font-weight: 700;
	min-width: 120px;
	font-family: "Montserrat", sans-serif;
	:hover {
		cursor: pointer;
	}
	span {
		font-size: 14px;
		font-weight: 600;
		text-align: left;
	}

	div {
		text-align: left;
		padding: 0px;
	}
	.attention-container {
		padding: ${(props) => props.desktop && "8px"};
		color: ${(props) => props.desktop && "#000"};
	}
	.attention-title {
		color: #282828;
		font-weight: 500;
	}
`;
